export default __webpack_public_path__ + "static/media/docIcon.d038445a.svg";